import "core-js/modules/es.array.filter";
import "core-js/modules/web.dom-collections.for-each";
var EVENTS = "__events";
export default {
  /**
   * Register a callback for an event
   */
  on: function on(event, callback) {
    var _this = this;

    var events = this[EVENTS];

    if (!events) {
      events = {};
      this[EVENTS] = events;
    }

    if (!events[event]) {
      events[event] = [];
    }

    events[event].push(callback);
    return function () {
      return _this.off(event, callback);
    };
  },

  /**
   * Fire an event and pass all additional parameters into the callback.
   */
  trigger: function trigger(event) {
    var _this2 = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var events = this[EVENTS];

    if (!events || !events[event]) {
      return;
    } // Add an event object to the callback parameters


    args.unshift({
      type: event,
      eventName: event
    });
    events[event].forEach(function (fn) {
      return fn.apply(_this2, args);
    });
  },

  /**
   * Removes a callback
   * @param event The name of the event to remove the callback from
   * @param callback Exact reference to the callback to be removed
   */
  off: function off(event, callback) {
    var events = this[EVENTS];

    if (!events || !events[event]) {
      return;
    }

    events[event] = events[event].filter(function (fn) {
      return fn != callback;
    });
  }
};